import React, { useEffect } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useParams } from 'react-router-dom';
import { useMediaQuery } from '@mui/material';
import HeaderSection from 'src/components/Vehicle/Detail/HeaderSection';
import LeftSection from 'src/components/Vehicle/Detail/LeftSection';
import RightSection from 'src/components/Vehicle/Detail/RightSection';
import { useSetBreadcrumbData } from 'src/utils/SetBreadcrumbData';
import { useSyncScroll } from 'src/utils/useSyncScroll';
import {
  getVehicleDetailsForOutward,
  resetVehicleDetails,
} from 'src/redux/Actions/VehicleTrackingOutward';
import 'src/style/tableList.css';
import 'src/style/detailPage.css';
import 'src/style/vehicleDetail.css';

export default function VehicleDetail() {
  const dispatch = useDispatch();
  const location = useLocation();
  const { vehicleId } = useParams();
  const isMobile = useMediaQuery('(max-width:767px)');
  const tenantOrganisationId = useSelector(
    (state) => state.AuthReducer?.userData?.organisations?.id,
  );
  const vehicle = useSelector(
    (state) => state.VehicleTrackingOutwardReducer?.vehicleDetailsForOutward,
  );
  const { leftColRef, rightColRef, resetScroll } = useSyncScroll(isMobile);

  useSetBreadcrumbData(location.pathname, vehicle?.vehicleNumber || '');

  useEffect(() => {
    if (tenantOrganisationId && vehicleId) {
      dispatch(resetVehicleDetails());
      dispatch(getVehicleDetailsForOutward(tenantOrganisationId, vehicleId));
    }

    return () => {
      dispatch(resetVehicleDetails());
    };
  }, [dispatch, tenantOrganisationId, vehicleId]);

  if (!vehicle?.id) return null;

  return (
    <div className="div-flex-column vehicle-detail-page-layout">
      <HeaderSection vehicle={vehicle} />
      <Row className="m-0">
        {!isMobile && (
          <Col
            xs={12}
            sm={12}
            md={3}
            lg={3}
            xl={3}
            xxl={3}
            className="p-0 left-col-sticky"
          >
            <div ref={leftColRef} className="left-section">
              <LeftSection vehicle={vehicle} />
            </div>
          </Col>
        )}

        <Col
          xs={12}
          sm={12}
          md={isMobile ? 12 : 9}
          lg={isMobile ? 12 : 9}
          xl={isMobile ? 12 : 9}
          xxl={isMobile ? 12 : 9}
          className={`px-0 ${!isMobile ? 'border-left' : ''}`}
        >
          <div ref={rightColRef} className="right-section">
            <RightSection vehicle={vehicle} onTabChange={resetScroll} />
          </div>
        </Col>
      </Row>
    </div>
  );
}
